import React from 'react';
import { Box } from '@mui/material';

const Footer = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                backgroundColor: '#37474f',
                flexDirection: 'column',
                height: 'auto',
                minHeight: '64px',
            }}
        >
            <Box
                sx={(theme) => ({
                    color: theme.palette.secondary.mainEvenLower,
                    fontFamily: theme.fontSecondary,
                    fontSize: '13px',
                    lineHeight: '1',
                })}
            >
                Built by&nbsp;
                <Box
                    component="a"
                    href="https://github.com/Wu-Bowen/personal-website"
                    rel="noopener noreferrer"
                    target="_blank"
                    sx={(theme) => ({
                        display: 'inline-block',
                        textDecoration: 'none',
                        textDecorationColor: 'transparent',
                        color: theme.palette.secondary.mainEvenLower,
                        transition:
                            'all 0.25s cubic-bezier(0.645,0.045,0.355,1)',
                        '&::after': {
                            content: '""',
                            width: '0px',
                            height: '2px',
                            display: 'block',
                            background: theme.palette.primary.textColorLower,
                            transition: '300ms',
                        },
                        '&:hover::after': {
                            width: '100%',
                        },
                        '&:hover': {
                            color: theme.palette.primary.textColorLower,
                        },
                    })}
                >
                    Eric Wu
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;
